import qs from 'qs';
import {useLocation} from 'react-router-dom';

export default () => qs.parse(useLocation().search, {ignoreQueryPrefix: true});